(function () {
  const loader = document.querySelector('[data-jamila-page-loader]');
  if (!loader) return;

  const root = document.documentElement;
  const startedAt = Date.now();
  const MINIMUM_DISPLAY = 250;
  const EXIT_DURATION = 200;
  const SAFETY_TIMEOUT = 2500;
  let finished = false;
  let safetyTimer;
  let minimumTimer;

  root.classList.add('jamila-page-is-loading');

  function finishLoading() {
    if (finished) return;
    finished = true;

    window.clearTimeout(safetyTimer);
    loader.classList.add('is-leaving');
    loader.setAttribute('aria-hidden', 'true');
    root.classList.remove('jamila-page-is-loading');

    window.setTimeout(function () {
      loader.hidden = true;
    }, EXIT_DURATION);
  }

  function finishWhenReady() {
    const remaining = MINIMUM_DISPLAY - (Date.now() - startedAt);

    if (remaining > 0) {
      window.clearTimeout(minimumTimer);
      minimumTimer = window.setTimeout(finishLoading, remaining);
      return;
    }

    finishLoading();
  }

  if (document.readyState !== 'loading') {
    finishWhenReady();
  } else {
    document.addEventListener('DOMContentLoaded', finishWhenReady, { once: true });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) finishLoading();
  }, { once: true });

  safetyTimer = window.setTimeout(finishLoading, SAFETY_TIMEOUT);
})();
